export type HabitFrequency = "daily" | "weekdays" | "weekends" | "custom";
export interface Schedule { frequency: HabitFrequency; custom_days: number[] | null; created_at: string }
export function habitDate(date = new Date()): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
export function habitIsDue(habit: Schedule, date = new Date()): boolean {
  if (habitDate(date) < habitDate(new Date(habit.created_at))) return false;
  const day = date.getDay();
  switch (habit.frequency) {
    case "daily": return true;
    case "weekdays": return day >= 1 && day <= 5;
    case "weekends": return day === 0 || day === 6;
    case "custom": return habit.custom_days?.includes(day) ?? false;
    default: return false;
  }
}
/** Consecutive scheduled completions. Today remains available until midnight. */
export function habitStreak(dates: string[], habit: Schedule, now = new Date()): number {
  const today = habitDate(now), completed = new Set(dates.filter(d => d <= today));
  if (!completed.size) return 0;
  const earliest = [...completed].sort()[0];
  const cursor = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12);
  let streak = 0;
  while (habitDate(cursor) >= earliest) {
    const day = habitDate(cursor);
    if (habitIsDue(habit, cursor)) {
      if (completed.has(day)) streak++;
      else if (day !== today) break;
    }
    cursor.setDate(cursor.getDate() - 1);
  }
  return streak;
}
export function newHabitId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
